var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "16.999",
        viewBox: "0 0 16.999 16.999",
        width: "16.999",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Group_2636",
            "data-name": "Group 2636",
            transform: "translate(-1775 -345.112)",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Icon_ionic-md-log-out",
                "data-name": "Icon ionic-md-log-out",
                transform: "translate(1771.625 341.737)",
              },
            },
            [
              _c("path", {
                attrs: {
                  id: "Path_2214",
                  d: "M13.5,16.047h7.752L19.47,17.874,20.692,19.1l3.923-3.923L20.692,11.25l-1.267,1.222L21.252,14.3H13.5Z",
                  "data-name": "Path 2214",
                  fill: "#afafaf",
                  transform: "translate(-4.241 -3.298)",
                },
              }),
              _vm._v(" "),
              _c(
                "g",
                {
                  attrs: {
                    id: "Group_2574",
                    "data-name": "Group 2574",
                    transform: "translate(3.375 3.375)",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      id: "Path_2215",
                      d: "M11.862,18.629a6.755,6.755,0,1,1,4.761-11.54l1.238-1.238A9.031,9.031,0,0,0,16.729,4.9a8.506,8.506,0,1,0,1.128,12.99L16.623,16.66A6.689,6.689,0,0,1,11.862,18.629Z",
                      "data-name": "Path 2215",
                      fill: "#afafaf",
                      transform: "translate(-3.375 -3.375)",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      id: "Path_2216",
                      d: "M31.458,17.958h.049v.049h-.049Z",
                      "data-name": "Path 2216",
                      fill: "#afafaf",
                      transform: "translate(-15.137 -9.483)",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }